import type { ReactNode } from "react";
import {
  ArrowClockwise,
  LockKey,
  SpinnerGap,
  Wrench,
} from "@phosphor-icons/react";

export function LoadingScreen() {
  return (
    <div className="full-state" role="status">
      <SpinnerGap className="spin" size={28} />
      <strong>正在验证会话</strong>
      <span>请稍候，正在连接 XMirror Connect。</span>
    </div>
  );
}

export function PageState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <section className="page-state">
      <span className="page-state-icon">{icon || <Wrench size={25} />}</span>
      <h2>{title}</h2>
      <p>{description}</p>
      {action}
    </section>
  );
}

export function ForbiddenState() {
  return (
    <PageState
      icon={<LockKey size={25} />}
      title="没有访问权限"
      description="当前账号没有访问该模块的权限，请联系租户管理员调整角色。"
    />
  );
}

export function QueryErrorState({ onRetry }: { onRetry(): void }) {
  return (
    <PageState
      title="数据加载失败"
      description="暂时无法连接管理端 API，请检查服务状态后重试。"
      action={
        <button className="secondary-button" onClick={onRetry}>
          <ArrowClockwise size={17} />
          重新加载
        </button>
      }
    />
  );
}
